import * as React from "react";

// Adding an event listener with CTRL + c handler to prevent bpmn.js/keyboard.js from handling the event and allow copy from the component
const useCtrlCopyInterceptor = () => {
    React.useEffect(() => {
      const handleKeyDown = (event: KeyboardEvent) => {
        if (event.ctrlKey && event.key === 'c') {
          event.stopPropagation();  // Prevent bpmn.js/keyboard.js from handling the event
        }
      };
  
      document.addEventListener('keydown', handleKeyDown, true);
  
      return () => document.removeEventListener('keydown', handleKeyDown, true);
    }, []);
  };
  
  export default useCtrlCopyInterceptor;